import { useQuery } from "@apollo/client";

import { ClientViewVouchersDocument } from "../../__generated__/graphql";
import { useClientId } from "../../shared";
import { isVoucherActive, voucherDiscountLabel, voucherExpiry } from "../voucher-list/lib";
import type { VoucherListItem } from "../voucher-list/types";

export function useClientViewVouchers() {
  const clientId = useClientId();
  const { data, loading, error, refetch } = useQuery(ClientViewVouchersDocument, {
    skip: !clientId,
    fetchPolicy: "cache-and-network",
    variables: { clientId },
  });

  const vouchers = data?.clientViewVouchers;
  const items: VoucherListItem[] = (vouchers ?? []).filter(isVoucherActive).map((voucher) => ({
    id: voucher.id,
    discount: voucherDiscountLabel(voucher),
    description: voucher.description ?? "",
    expiry: voucherExpiry(voucher.validUntil),
  }));

  return {
    items,
    loading: !vouchers && loading,
    error: vouchers ? undefined : error,
    refetch,
  };
}
